import {
    buildValidationsFromConfig,
} from '@/helpers/validation';

const config = {
    extraAdultPriceType: {
        name: 'Price Type',
        required: true,
    },
    refundableAmountType: {
        name: 'Refundable Amount Type',
        required: true,
    },
};

export default buildValidationsFromConfig(config);
